import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Grid,
  GridItem,
  Badge,
  Button,
  useToast,
  Divider,
  Spinner,
} from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import * as mod from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";

const CandidateDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(false);

  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const config = { headers: { Authorization: `${token}` } };

  const fetchCandidate = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/election/candidate/${id}`,
        config,
      );
      setCandidate(data?.data || data);
    } catch (error) {
      toast({
        title: "Failed to load candidate",
        status: "error",
        duration: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidate();
  }, [id]);

  const handleBulkVote = async (candidateId, categoryId) => {
    const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
    const token = storedData?.data?.token;
    const config = { headers: { Authorization: `${token}` } };
    if (!token) {
      toast({
        title: "Unauthorized",
        description: "Admin token missing",
        status: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${mod.api_url}/api/v1/election/vote/vote/bulk`, // ✅ full URL OR proxy
        {
          candidateId,
          categoryId,
          count: 8,
        },
        config,
      );

      toast({
        title: "Success",
        description: res.data.message,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.message || "Failed to add votes",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <Box textAlign="center" mt={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (!candidate) return null;

  return (
    <>
      <Sidebar />
      <Navbar />

      <Box ml={{ base: 0, md: "250px" }} mt="70px" p={5} bg="gray.50">
        <Container maxW="6xl">
          <Button mb={4} onClick={() => navigate(-1)}>
            ← Back
          </Button>
          <Button
            mb={4}
            onClick={() =>
              navigate(`/updateBYadmin/candidate/${candidate._id}`)
            }
            ml={4}
            colorScheme="blue"
          >
            Update Candidate
          </Button>
          {/* <Button
            mb={4}
            ml={4}
            colorScheme="green"
            isLoading={loading}
            onClick={() =>
              handleBulkVote(candidate._id, candidate.category._id)
            }
          >
            +8 Votes
          </Button> */}
          <Heading mb={4}>Candidate Details</Heading>

          <Badge colorScheme={candidate.isVerified ? "green" : "orange"} mb={4}>
            {candidate.isVerified ? "Verified" : "Pending Approval"}
          </Badge>

          <Divider mb={6} />

          <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap={6}>
            {/* LEFT: PHOTOS */}
            <GridItem>
              <Image
                src={`${mod.api_url}${candidate.photo}`}
                borderRadius="md"
                mb={4}
                boxShadow="md"
              />

              <Text fontWeight="bold" mb={2}>
                Bar ID / Enrollment Proof
              </Text>
              <Image
                src={`${mod.api_url}${candidate?.barIdPhoto}`}
                borderRadius="md"
                boxShadow="md"
              />
            </GridItem>

            {/* RIGHT: DETAILS */}
            <GridItem>
              <Text>
                <b>Name:</b> {candidate?.name}
              </Text>
              <Text>
                <b>Email:</b> {candidate?.email}
              </Text>
              <Text>
                <b>Mobile:</b> {candidate?.mobile}
              </Text>
              <Text>
                <b>Enrollment No:</b> {candidate?.enrollmentNo}
              </Text>
              <Text>
                <b> Awards Category:</b> {candidate?.category.name}
              </Text>

              <Divider my={4} />

              <Text fontWeight="bold">About Candidate</Text>
              <Text color="gray.600">{candidate.aboutus}</Text>

              <Divider my={4} />

              <Text fontWeight="bold" mb={2}>
                Cover Letter
              </Text>

              <Box
                border="1px solid #e2e8f0"
                borderRadius="md"
                overflow="hidden"
                w="100%"
                h={{ base: "400px", md: "600px" }}
              >
                <iframe
                  src={`${mod.api_url}${candidate.coverLaterpdf}`}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                  title="Cover Letter PDF"
                />
              </Box>
            </GridItem>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default CandidateDetails;
